<template>
  <div>
    <div :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>

    <!-- <HeaderView :imgHeader="configuracion.Url " :dataHeader="infoHeader.TextHeader"></HeaderView> -->
    <!-- <div class="overlay-div-contact" :style="{'background-image': 'url(' + imgContat + ')'}">
       
      <div class="text-light overlay-text d-flex flex-column justify-content-center pl-xl-5 mx-xl-5 ">
        <h2>Contacta con nosotros</h2>
        <p>
          <b>
            <span class="pointer" @click="$router.push('/')">Inicio</span>  >> Contacta con nosotros
          </b>
        </p>
      </div>
    </div> -->

    <div class="bg-light">
      <div class="container-lg py-5">
        <div class="row">
          <div
            :class="
              ConfiguracionGeneral.Contacto_Panel_Derecho != ''
                ? 'col-lg-6'
                : 'col-lg-8 offset-lg-2'
            "
            class="px-3 px-sm-5"
          >
            <div class="pr-xl-3" data-aos="fade-up">
              <b-form @submit.prevent="enviarSolicitud">
                <b>
                  <h1 class="h2">{{ $t('contact.heading') }}</h1>
                  <div class="form-container">
                    <div class="form-group-line">
                      <i class="fa-solid fa-user"></i>
                      <input
                        required
                        type="text"
                        :placeholder="$t('contact.namePlaceholder')"
                        v-model="row.Nombre"
                      />
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group-line">
                          <i class="fa-solid fa-phone"></i>
                          <input
                            required
                            type="tel"
                            :placeholder="$t('contact.phonePlaceholder')"
                            v-model="row.Telefono"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group-line">
                          <i class="fa-solid fa-envelope"></i>
                          <input
                            required
                            type="email"
                            :placeholder="$t('contact.emailPlaceholder')"
                            v-model="row.Correo"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group-line">
                      <textarea
                         required
                        rows="3"
                        :placeholder="$t('contact.messagePlaceholder')"
                        v-model="row.Mensaje"
                      ></textarea>
                    </div>
                  </div>
                  <div>
                    <button type="submit" class="btn btn-primary">{{ $t('contact.submitButton') }}</button>
                  </div>
                </b>
              </b-form>
            </div>
          </div>
          <div
            v-if="ConfiguracionGeneral.Contacto_Panel_Derecho != ''"
            class="col-lg-6 mt-md-0 pt-3 px-md-0 px-3"
          >
            <div class="bg-white p-4 shadow rounded" data-aos="fade-up" data-aos-delay="200">
              <div
                class="mt-3 pr-xl-5"
                v-html="ConfiguracionGeneral.Contacto_Panel_Derecho"
              ></div>
              <!-- <h2>¡Bienvenido!</h2>
              <p class="mt-3 text-secondary">
                Las residencias conectadas pueden ser propiedad de una sola
                entidad y arrendarse, o ser de propiedad separada con un acuerdo
                que cubra la relación entre las unidades, áreas comunes y
                preocupaciones.
              </p> -->
              <!-- <div>
                <h5 class="text-black">
                  <span
                    ><i
                      class="fa-solid fa-location-dot text-primary mr-2"
                    ></i></span
                  >¿Dónde?
                </h5>
                <p class="text-secondary">
                  549 Sulphur Springs Road Downers Grove, IL 60515 +91 361264100
                </p>
              </div>
              <div>
                <h5 class="text-black">
                  <span
                    ><i
                      class="fa-solid fa-location-dot text-primary mr-2"
                    ></i></span
                  >Servicio en línea
                </h5>
                <p class="text-secondary">
                  Consultas: sheltos@.in Soporte: help@.in www.test.com +86 163
                  - 451 - 7894
                </p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "../components/HeaderView.vue";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";

export default {
  components: { HeaderView },
  props: ["NavSolid"],
  data() {
    return {
      ConfiguracionGeneral: {},
      configuracion: [],
      row: { Nombre: "", Telefono: "", Mensaje: "", Correo: "" },
      Contacto_panel_derecho: "",
      infoHeader: {
        img: "https://img.freepik.com/fotos-premium/paredes-pisos-naranjas-sala-estar_1086760-36225.jpg?w=826",
        TextHeader: "Contacta con nosotros",
      },
      
    };
  },
  async created() {
    await this.getConfiguracion();
  },
  async mounted() {},
  methods: {
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    async enviarSolicitud() {
      try {
        // this.obtenerRutaActual();
        // console.log(this.agente);
        // this.row.propiedad = this.propiedad;
        let respuesta = await this.$store.dispatch("post", {
          path: "Agente/envioCorreoContacto/contacto",
          data: { ...this.row, Domain: this.resolvePublicDomain() },
        });
        console.log("envio correo -----", respuesta.status);
        this.$swal({
          icon: "success",
          title: this.$t('common.successTitle'),
          text: this.$t('contact.successMessage'),
        });
        this.row.Mensaje = "";
        this.row.Nombre = "";
        this.row.Telefono = "";
        this.row.Correo = "";
      } catch (error) {
        console.log("error", error);
      }
    },
    async getConfiguracion() {
      try {
        const resolvedDomain = this.resolvePublicDomain();
        let res = await this.$store.dispatch("get", {
          path: `Configuracion_Imagenes_Web/public/getAll?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        let ConfiguracionGeneral = await this.$store.dispatch("get", {
          path: `Configuracion_General/public/getAll?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        console.log("----ConfiguracionGeneral---", ConfiguracionGeneral);
        this.ConfiguracionGeneral = ConfiguracionGeneral[0];
        console.log("*----res*", res);
        if (res.length > 0) {
          this.configuracion = res[0];
        } else {
          this.configuracion = [];
        }
      } catch (error) {
        this.configuracion = [];
      }
    },
  },
};
</script>

<style scoped>
.form-container {
  background-color: transparent !important;
}

textarea {
  resize: none;
}
</style>
